import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getCooperationsReq,
  removeCooperationReq,
} from "../state-management/actions/cooperation-requset-actions";
import { getCooperationsAppricants } from "../state-management/actions/cooperation-appricants-actions";
import { getCooperations } from "../state-management/actions/cooperation-actions";
import Container from "../components/basicComponents/container";
import Grid from "../components/grid";
import {
  setAlert,
  setAlertContext,
  setAlertSeverity,
} from "../state-management/actions/alerts-actions";
import { cooperationRequestProps } from "../types/public";
import formatDateToPersian from "../utils/formatDate";
import { selectGlobalState } from "../state-management/selectors";

export default function CooperationReq() {
  const dispatch = useDispatch();
  const { currentUserData, groupingData } = useSelector(selectGlobalState);
  const [data, setData] = useState<cooperationRequestProps[]>([]);
  const [flag, setFlage] = useState<boolean>(false);

  const permissionDepartment = groupingData.find(
    (item: any) => item.user_id === currentUserData._id
  )?.department_id || ["none"];

  useEffect(() => {
    const fetch = async () => {
      const coopretion = await getCooperations()(dispatch);
      const coopReq = await getCooperationsReq()(dispatch);
      const coopAcp = await getCooperationsAppricants()(dispatch);

      const finalData = coopReq.data.map((req: any) => {
        const applicant = coopAcp.data.find(
          (ap: any) => ap._id === req.appricant_id
        );
        const cooperation = coopretion.data.find(
          (coop: any) => coop._id === req.cooperation_id
        );

        return {
          _id: req._id,
          department_id: cooperation?.department_id,
          advertiseName: cooperation?.title || "بدون عنوان",
          requester: applicant
            ? `${applicant.firstname} ${applicant.lastname}`
            : "نامشخص",
          requseterEmail: applicant?.email || "نامشخص",
          requestTime: formatDateToPersian(req.created_at),
          resume: applicant?.resume
            ? `data:application/pdf;base64,${applicant?.resume}`
            : "رزومه‌ای وجود ندارد",
        };
      });

      setData(
        finalData.filter((item: any) =>
          permissionDepartment.includes(item?.department_id)
        )
      );
    };

    fetch();
  }, [dispatch, flag]);

  const handleDelete = async (id: string) => {
    console.log(id);
    try {
      const response = await removeCooperationReq(id)(dispatch);
      if (response.data) {
        dispatch(setAlert(true));
        dispatch(setAlertSeverity("success"));
        dispatch(setAlertContext(" درخواست مربوطه حذف شد"));
        setFlage((prev) => !prev);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="py-10 w-full">
      <Container header="لیست درخواست  ها">
        <Grid
          height={500}
          columns={[
            { headerName: "عنوان آگهی", field: "advertiseName" },
            { headerName: "درخواست‌کننده", field: "requester" },
            { headerName: "ایمیل درخواست‌کننده", field: "requseterEmail" },
            { headerName: "زمان ارسال درخواست", field: "requestTime" },
            {
              headerName: "رزومه",
              field: "resume",
              cellRenderer: (params: any) => {
                if (!params.value || params.value === "رزومه‌ای وجود ندارد")
                  return "-";
                return (
                  <a
                    className="text-blue-600 underline hover:text-blue-800"
                    href={params.value}
                    download={`${params.data.requester}_resume.pdf`}
                  >
                    دانلود
                  </a>
                );
              },
            },
          ]}
          userData={data}
          pageSize={50}
          pagination={true}
          editBtn={false}
          deleteBtn={true}
          editable={false}
          btnHeader="عملیات"
          handleDelete={handleDelete}
        />
      </Container>
    </div>
  );
}
